import React, { useState } from "react"
import { OptionButton } from "./option-button"
import { CustomInput } from "./custom-input"

const MARGIN = {
  none: 0,
  normal: 24,
  large: 48
}

function allMarginsEqual(properties, value) {
  return properties.marginTop === value && properties.marginBottom === value
}

function getMargin(properties) {
  if (allMarginsEqual(properties, MARGIN.none)) return "none"
  if (allMarginsEqual(properties, MARGIN.normal)) return "normal"
  if (allMarginsEqual(properties, MARGIN.large)) return "large"
  return "custom"
}

export function Margin({ properties, update }) {
  const margin = getMargin(properties)
  const [showCustom, setShowCustom] = useState(margin === "custom")

  function handleMarginClick(size) {
    setShowCustom(false)
    update({
      marginTop: MARGIN[size],
      marginBottom: MARGIN[size]
    })
  }

  return (
    <div>
      <div className="font-semibold text-gray-700 mb-1">Margin</div>
      <div className="flex border rounded mb-2">
        <div className="p-1 flex items-center justify-center flex-grow border-r">
          <OptionButton
            active={margin === "none" && !showCustom}
            onClick={() => handleMarginClick("none")}
          >
            None
          </OptionButton>
          <OptionButton
            active={margin === "normal" && !showCustom}
            onClick={() => handleMarginClick("normal")}
          >
            Normal
          </OptionButton>
          <OptionButton
            active={margin === "large" && !showCustom}
            onClick={() => handleMarginClick("large")}
          >
            Large
          </OptionButton>
        </div>
        <div className="p-1 flex items-center justify-center">
          <OptionButton
            active={margin === "custom" || showCustom}
            onClick={() => setShowCustom(true)}
          >
            Custom
          </OptionButton>
        </div>
      </div>

      {showCustom && (
        <div className="grid grid-cols-2 gap-2">
          <CustomInput
            label="Top"
            value={properties.marginTop}
            onChange={value => update({ marginTop: value })}
          />

          <CustomInput
            label="Bottom"
            value={properties.marginBottom}
            onChange={value => update({ marginBottom: value })}
          />
        </div>
      )}
    </div>
  )
}
